export default "__VITE_PUBLIC_ASSET__2d1f1fb1__"